/* eslint-disable react/prefer-stateless-function */
import React from 'react'
import SessionContext from '../contexts/SessionContext'
import hoistNonReactStatics from 'hoist-non-react-statics'
import forwardInnerRef from './forwardInnerRef'

const withSession = () => {
  return Component => {
    // eslint-disable-next-line react/require-render-return
    class WrappedComponent extends React.Component {
      render() {
        return (
          <SessionContext.Consumer>
            {session => <Component {...this.props} session={session} />}
          </SessionContext.Consumer>
        )
      }
    }

    //@ts-ignore
    WrappedComponent.displayName = `RFWithSession(${Component.displayName})`
    hoistNonReactStatics(WrappedComponent, Component)

    return forwardInnerRef(WrappedComponent)
  }
}

export default withSession
